export default __webpack_public_path__ + "static/media/js.c4c89593.svg";